export const contact = {
  en: {
    title: 'Contact',
    form: {
      name: {
        label: 'Name',
        placeholder: 'Enter your name'
      },
      email: {
        label: 'Email',
        placeholder: 'Enter your email'
      },
      subject: {
        label: 'Subject',
        placeholder: 'Enter subject'
      },
      message: {
        label: 'Message',
        placeholder: 'Enter your message'
      },
      submit: 'Send',
      success: 'Message sent successfully! Thank you for contacting me.',
      error: 'There was an error sending your message. Please try again.'
    }
  },
  pt: {
    title: 'Contato',
    form: {
      name: {
        label: 'Nome',
        placeholder: 'Digite seu nome'
      },
      email: {
        label: 'Email',
        placeholder: 'Digite seu email'
      },
      subject: {
        label: 'Assunto',
        placeholder: 'Digite o assunto'
      },
      message: {
        label: 'Mensagem',
        placeholder: 'Digite sua mensagem'
      },
      submit: 'Enviar',
      success: 'Mensagem enviada com sucesso! Obrigado por entrar em contato.',
      error: 'Houve um erro ao enviar sua mensagem. Por favor, tente novamente.'
    }
  }
};